var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('GYHeader',{on:{"scroll":_vm.scrollTo}}),_c('router-view',{ref:"rv"}),_c('GYFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }